import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页仪表盘', icon: 'el-icon-data-line' }
      },
      {
        path: 'product',
        name: 'ProductRoot',
        redirect: '/product/list',
        component: { render: h => h('router-view') },
        meta: { title: '产品管理', icon: 'el-icon-goods' },
        children: [
          {
            path: 'list',
            name: 'ProductList',
            component: () => import('@/views/product/list.vue'),
            meta: { title: '产品列表' }
          },
          {
            path: 'add',
            name: 'ProductAdd',
            component: () => import('@/views/product/edit.vue'),
            meta: { title: '新增产品', hidden: true }
          },
          {
            path: 'edit/:id',
            name: 'ProductEdit',
            component: () => import('@/views/product/edit.vue'),
            meta: { title: '编辑产品', hidden: true }
          }
        ]
      },
      {
        path: 'category',
        name: 'Category',
        component: () => import('@/views/category/index.vue'),
        meta: { title: '分类管理', icon: 'el-icon-menu' }
      },
      {
        path: 'tag',
        name: 'Tag',
        component: () => import('@/views/tag/index.vue'),
        meta: { title: '标签管理', icon: 'el-icon-collection-tag' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user', requireRole: 'admin' }
      },
      {
        path: 'butler',
        name: 'Butler',
        component: () => import('@/views/butler/index.vue'),
        meta: { title: '管家管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '管理员账号', icon: 'el-icon-key', requireRole: 'admin' }
      },
      {
        path: 'home-banner',
        name: 'HomeBanner',
        component: () => import('@/views/home-banner/index.vue'),
        meta: { title: '首页Banner', icon: 'el-icon-picture-outline' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/index.vue'),
        meta: { title: '系统设置', icon: 'el-icon-setting' }
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/login/index.vue'), // 占位，后端补 404.vue 后替换
    meta: { title: '页面不存在', noAuth: true }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - 锦辉定制旅游后台`
  }

  // 无需鉴权页面直接放行
  if (to.meta && to.meta.noAuth) {
    // 已登录用户访问 /login 跳到首页
    const existingToken = store.state.user.token || localStorage.getItem('admin_token')
    if (existingToken && to.path === '/login') {
      next('/dashboard')
      return
    }
    next()
    return
  }

  const token = store.state.user.token || localStorage.getItem('admin_token')
  if (!token) {
    next('/login')
    return
  }

  // 路由级角色限制
  if (to.meta && to.meta.requireRole) {
    let adminInfo = store.state.user.info
    if (!adminInfo) {
      try {
        adminInfo = JSON.parse(localStorage.getItem('admin_info') || 'null')
      } catch (e) {
        // JSON 解析失败，清 token 跳登录
        store.dispatch('logout')
        next('/login')
        return
      }
    }
    const role = adminInfo && adminInfo.role
    if (role !== to.meta.requireRole) {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
